<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.delete" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="title">Peringatan !</v-card-title>
        <v-card-text>Apakah anda yakin ingin menghapus data ini ?</v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#ff618a"
            elevation="0"
            :disabled="process.form"
            :loading="process.form"
            class="white--text text-capitalize"
            @click="deletes">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            class="text-capitalize"
            :disabled="process.form"
            @click="dialog.delete = false; form.sosmedId = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div class="title text--secondary mb-5">
          {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Sosial Media
        </div>
        <ValidationObserver ref="observer">
          <v-form>
            <ValidationProvider name="Judul" rules="required" v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                label="Judul"
                color="#ff618a"
                v-model="form.sosmedTitle"
                :error-messages="errors"
                require>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Link" rules="required" v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                label="Link"
                color="#ff618a"
                v-model="form.sosmedUrl"
                :error-messages="errors"
                require>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
              <v-select
                :items="[
                  {
                    title: 'Draft', 
                    value: 'draft'
                  },
                  {
                    title: 'Publish', 
                    value: 'publish'
                  }
                ]"
                item-text="title"
                item-value="value"
                dense
                outlined
                color="#ff618a"
                label="Status"
                v-model="form.sosmedStatus"
                :error-messages="errors"
                require>
              </v-select>
            </ValidationProvider>
            <div class="mb-3">
              <p class="mb-1">Gambar</p>
              <form class="mt-1">
                <v-card flat width="220" class="pa-0" style="background: transparent;">
                  <image-input v-model="avatar" type="uploadCover">
                    <div slot="activator">
                      <v-avatar tile size="100" height="100" class="grey lighten-3 c-p" v-ripple>
                        <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                          <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            class="mx-4 mt-4"
                            style="width: 80px;">
                          </v-progress-linear>
                          <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                          </p>
                          </div>
                        <img v-if="avatar && !addImage" 
                        :src="form.sosmedImage" 
                        :alt="form.sosmedImage"  
                        width="200"
                        height="200"/>
                      </v-avatar>
                    </div>
                  </image-input>
                </v-card>
              </form>
              <p
                class="caption text-left mt-1 red--text"
                v-show="error.sosmedIcon">
                {{ error.sosmedIcon }}
              </p>
            </div>
            <div>
              <v-alert
                type="error"
                text
                dense
                prominent
                v-show="response !== ''">
                {{ response }}
              </v-alert>
            </div>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn
                small
                rounded
                width="100"
                color="#FF618A"
                elevation="0"
                :disabled="process.form"
                :loading="process.form"
                @click="save"
                class="white--text text-capitalize">
                Simpan
              </v-btn>
              <v-btn
                rounded
                small
                width="100"
                elevation="0"
                :disabled="process.form"
                class="text-capitalize"
                @click="reset(undefined, 'mobile'); selectedPage = 'create'; $refs.observer.reset()">
                Batal
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex' : ''">
          <v-text-field
            filled
            rounded
            dense
            :hide-details="true"
            placeholder="Cari sosial media . . ."
            v-model="filter.title"
            clearable
            color="#ff618a"
            @click:clear="filter.title = ''; fetch();showPage = false"
            v-on:keyup.enter="fetch(); showPage = false"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn
            :color="!showPage ? '#FF618A ' : '#F5F5F5'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            :dark="!showPage"
            elevation="0"
            rounded
            :light="showPage"
            :disabled="process.form"
            v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(undefined, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(undefined, 'mobile') : reset()"
            @click="selectedPage = 'create';">
            <span v-if="!showPage">Tambah Sosial Media</span>
            <span v-if="showPage">Batal</span>
          </v-btn>
        </div>
        <div class="my-5" :class="showPage ? 'pr-5' : 'pl-0'">
          <div class="title text--secondary">Data Sosial Media</div>
          <div class="caption text--secondary">{{pagination.totalData}} Sosial Media Ditemukan</div>
        </div>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.name === 'xs' ? '6' : '3'" :sm="$vuetify.breakpoint.name === 'xs' ? '6' : '3'" 
            v-for="(l, index) in process.run ? 12:list" 
            :key="index">
            <v-skeleton-loader
              class="ma-5"
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              height="100" 
              width="100"  
              type="card">
              <v-hover v-slot:default="{ hover }">
                <v-card 
                  raised 
                  flat 
                  height="100" 
                  width="100"  
                  class="ma-5">
                  <div v-if="!process.run">
                    <v-img
                      contain
                      height="100" 
                      width="100"
                      :src="l.sosmedIcon"
                      :gradient="hover ? 'to top, rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)' : ''"
                      class="mx-auto br-20 d-flex text-center align-center bg-poto c-p">
                      <div>
                        <v-btn
                          fab
                          x-small
                          dark
                          :disabled="process.form"
                          color="#269B91"
                          elevation="0"
                          class="text-capitalize white--text ma-1"
                          v-on:click="$vuetify.breakpoint.name === 'xs' ? reset(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? reset(l, 'mobile') : reset(l)"
                          @click="selectedPage = 'update'"
                          v-if="hover">
                          <v-icon small>mdi-square-edit-outline</v-icon>
                        </v-btn>
                        <v-btn 
                          fab
                          x-small
                          dark
                          color="red"
                          elevation="0"
                          class="text-capitalize ma-1"
                          :disabled="process.form"
                          @click="form.sosmedId = l.id; dialog.delete = true"
                          v-if="hover">
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </div>
                    </v-img>
                    <div class="text-center mt-4 px-3">
                      <v-list-item-title
                        class="body-2 font-weight-bold grey--text text--darken-2">{{l.sosmedTitle}}</v-list-item-title>
                    </div>
                  </div>
                </v-card>
              </v-hover>
            </v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <Empty v-show="!process.run && list.length < 1" content="Data Sosial Media"/>
            <div v-if="pagination.totalPage > 1">
              <v-row>
                <v-col cols="5">
                  <div class="body-2 font-weight-bold mt-4">Total {{ pagination.totalData }} data</div>
                </v-col>
                <v-col cols="7">
                  <div class="float-right">
                    <v-pagination
                      v-model="page"
                      :length="pagination.totalPage"
                      :total-visible="5"
                      color="#ff618a"
                      @input="fetch(page);showPage = false"
                      circle>
                    </v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="4" class="mt-3 background-default pa-7" v-if="showPage && $vuetify.breakpoint.name !== 'xs'">
        <div class="title text--secondary mb-5">
          {{ selectedPage === 'create' ? 'Tambah' : 'Ubah' }} Sosial Media
        </div>
        <ValidationObserver ref="observer">
          <v-form>
            <ValidationProvider name="Judul" rules="required" v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                label="Judul"
                color="#ff618a"
                v-model="form.sosmedTitle"
                :error-messages="errors"
                require>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Link" rules="required" v-slot="{ errors }">
              <v-text-field
                dense
                outlined
                label="Link"
                color="#ff618a"
                v-model="form.sosmedUrl"
                :error-messages="errors"
                require>
              </v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
              <v-select
                :items="[
                  {
                    title: 'Draft', 
                    value: 'draft'
                  },
                  {
                    title: 'Publish', 
                    value: 'publish'
                  }
                ]"
                item-text="title"
                item-value="value"
                dense
                outlined
                color="#ff618a"
                label="Status"
                v-model="form.sosmedStatus"
                :error-messages="errors"
                require>
              </v-select>
            </ValidationProvider>
            <div class="mb-3">
              <p class="mb-1">Gambar</p>
              <form class="mt-1">
                <v-card flat width="220" class="pa-0" style="background: transparent;">
                  <image-input v-model="avatar" type="uploadCover">
                    <div slot="activator">
                      <v-avatar tile size="100" height="100" class="grey lighten-3 c-p" v-ripple>
                        <v-icon v-if="!avatar && addImage === ''" color="grey darken-3" large>mdi-camera</v-icon>
                          <div class="px-5" v-if="addImage && avatar.url === undefined">
                            <v-progress-linear
                            color="#ff618a"
                            indeterminate
                            rounded
                            height="6"
                            class="mx-4 mt-4"
                            style="width: 80px;">
                          </v-progress-linear>
                          <p class="mt-2 mx-4 mb-0" style="font-size: 9px;">
                              Mengupload Gambar . . .
                          </p>
                          </div>
                        <img v-if="avatar && !addImage" 
                        :src="form.sosmedImage" 
                        :alt="form.sosmedImage"  
                        width="200"
                        height="200"/>
                      </v-avatar>
                    </div>
                  </image-input>
                </v-card>
              </form>
              <p
                class="caption text-left mt-1 red--text"
                v-show="error.sosmedIcon">
                {{ error.sosmedIcon }}
              </p>
            </div>
            <div>
              <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
            </div>
            <v-card-actions class="mt-3">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                light
                width="200"
                color="#FF618A"
                elevation="0"
                :disabled="process.form"
                :loading="process.form"
                @click="save"
                class="white--text text-capitalize">
                Simpan
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import ImageInput from "../../../../components/ImageInput.vue";
  import Empty from "../../../../components/DataEmpty";
  export default {
    data() {
      return {
        avatar: "",
        dialog: {
          delete: false,
          form: false
        },
        showPage: false,
        filter: {
          title: ""
        },
        addImage:'',
        selectedPage: '',
        list: [],
        pagination: {},
        page: 1,
        form: {
          sosmedId: "",
          sosmedTitle: "",
          sosmedImage: "",
          sosmedUrl: "",
          sosmedStatus:""
        },
        error: {
          sosmedIcon: ""
        },
        process: {
          form: false,
          run: false
        },
        response: ""
      };
    },
    components: {
      ImageInput,
      Empty
    },
    watch: {
      avatar: {
        handler: function () {
          this.form.sosmedImage = this.avatar ? this.avatar.url : ""
          this.addImage = this.avatar.add
          this.error.sosmedIcon = ''
        },
        deep: true
      }
    },
    computed: {},
    mounted() {
      window.scrollTo(0, 0);
      this.fetch();
    },
    methods: {
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        }
        this.process.run = true;
        await get(`api/internal/sosmed/list`, {
          params: {
            pagenum: p,
            limit: 12,
            search:this.filter.title ? 'sosmed_title:'+this.filter.title : '',
          }
        }).then(response => {
          let res = response.data;
          if (res.code === 200) {
            this.process.run = false;
            this.list = res.data;
            this.pagination = res.pagination;
          }
        });
      },
      reset(item, status) {
        this.showPage = status !== undefined ? false : !this.showPage ? true : false

        this.avatar = item !== undefined ? {
          url: item.sosmedIcon
        } : ''

        this.form = {
          sosmedId: item !== undefined ? item.id : "",
          sosmedTitle : item !== undefined ? item.sosmedTitle : "",
          sosmedUrl: item !== undefined ? item.sosmedUrl : "",
          sosmedImage: item !== undefined ? item.sosmedIcon : "",
          sosmedStatus: item !== undefined ? item.sosmedStatus : "",
        }
        this.addImage = item !== undefined ? false : ""
        this.selectedPage = ''
        this.process.form = false

        this.error = {
          sosmedIcon: ""
        }
        this.dialog.form = status !== undefined ? !this.dialog.form ? true : false : false
        this.response = ''
      },
      validation() {
        var error = this.error,
          valid = true;

        if (this.form.sosmedImage === "") {
          error.sosmedIcon = "Gambar tidak boleh kosong";
          valid = false;
        } else {
          error.sosmedIcon = "";
        }

        return valid;
      },
      async save() {
        this.response = "";
        const valids = this.validation();
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          if (this.form.sosmedId === "") {
            this.creates();
          } else {
            this.updates();
          }
        }
      },
      async creates() {
        this.process.form = true;
        await post(`api/internal/sosmed/create`, {
          data: {
            sosmedTitle: this.form.sosmedTitle,
            sosmedUrl: this.form.sosmedUrl,
            sosmedIcon: this.form.sosmedImage,
            sosmedStatus: this.form.sosmedStatus
          }
        }).then(response => {
          let res = response.data;
          if (res.code == 201) {
            this.fetch();
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async updates() {
        this.process.form = true;
        await put(`api/internal/sosmed/update/${this.form.sosmedId}`, {
          data: {
            sosmedTitle: this.form.sosmedTitle,
            sosmedIcon: this.form.sosmedImage,
            sosmedUrl: this.form.sosmedUrl,
            sosmedStatus: this.form.sosmedStatus
          }
        }).then(response => {
          let res = response.data;
          if (res.code === 201) {
            this.fetch(this.page);
            if (this.dialog.form === true) {
              this.reset(undefined, 'mobile')
            } else {
              this.reset();
            }
          } else {
            this.process.form = false;
            this.response = res.msg;
          }
        });
      },
      async deletes() {
        this.process.form = true;
        await destroy(`api/internal/sosmed/delete/${this.form.sosmedId}`)
        .then((response) => {
          let res = response.data;
          if (res.code === 201) {
            this.process.form = false
            this.dialog.delete = false
            this.showPage = false
            this.form.sosmedId = ''
            this.fetch()
          } else {
            this.process.form = false
            this.response = res.msg
          }
        })
      }
    }
  };
</script>
